import React, { useState } from "react";
import DoubleArrowIcon from "@material-ui/icons/DoubleArrow";
import { makeStyles } from "@material-ui/core/styles";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Slide from "@material-ui/core/Slide";
import { InlineMath } from "react-katex";
import SkipNextIcon from "@material-ui/icons/SkipNext";
import SkipPreviousIcon from "@material-ui/icons/SkipPrevious";
import MediaQuery from "react-responsive";
import Marimencoba from "../3/Marimencoba";
import Iframe from "react-iframe";
import { MathComponent } from "mathjax-react";
const useStyles = makeStyles((theme) => ({
	appBar: {
		position: "relative",
		backgroundColor: "#40bf80",
	},
	title: {
		margin: "auto",
	},
}));

const Transition = React.forwardRef(function Transition(props, ref) {
	return <Slide direction="up" ref={ref} {...props} />;
});
const Ch4 = ({ukuranH,ukuranP}) => {
	const classes = useStyles();
	const [jawaban4, setJawaban4] = useState(false);
	const clickSetJawaban4 = () => setJawaban4(!jawaban4);
	const [openmencobadialog, setOpenmencobadialog] = useState(false);
	const openMencobaDialog = () => {
		setOpenmencobadialog(true);
	};
	const closemencobaDialog = () => {
		setOpenmencobadialog(false);
	};

	const [show1, setShow1] = useState(false);
	const [show2, setShow2] = useState(false);
	const [show3, setShow3] = useState(false);
	const [show4, setShow4] = useState(false);
	const [show5, setShow5] = useState(false);
	const [show6, setShow6] = useState(false);
	const [show7, setShow7] = useState(false);
	const [show8, setShow8] = useState(false);
	const [show9, setShow9] = useState(false);
	const [show10, setShow10] = useState(false);
	const [show11, setShow11] = useState(false);
	const [show12, setShow12] = useState(false);
	const [show13, setShow13] = useState(false);
	const [show14, setShow14] = useState(false);
	const [show15, setShow15] = useState(false);
	const [show16, setShow16] = useState(false);
	const [form1, setForm1] = useState({ width: "50px", height: "30px" });
	const [form2, setForm2] = useState({ width: "50px", height: "30px" });
	const [form3, setForm3] = useState({ width: "50px", height: "30px" });
	const [form4, setForm4] = useState({ width: "50px", height: "30px" });
	const [form5, setForm5] = useState({ width: "50px", height: "30px" });
	const [form6, setForm6] = useState({ width: "50px", height: "30px" });
	const [form7, setForm7] = useState({ width: "50px", height: "30px" });
	const [form8, setForm8] = useState({ width: "50px", height: "30px" });
	const [form9, setForm9] = useState({ width: "50px", height: "30px" });
	const [form10, setForm10] = useState({ width: "50px", height: "30px" });
	const [form11, setForm11] = useState({ width: "50px", height: "30px" });
	const [form12, setForm12] = useState({ width: "50px", height: "30px" });
	const [form13, setForm13] = useState({ width: "50px", height: "30px" });
	const [form14, setForm14] = useState({ width: "50px", height: "30px" });
	const [form15, setForm15] = useState({ width: "60px", height: "30px" });
	const [form16, setForm16] = useState({ width: "60px", height: "30px" });
	const handForm1 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow1(true);
			setForm1({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm1({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm1({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm2 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow2(true);
			setForm2({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm2({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm2({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm3 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow3(true);
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm3({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm4 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShow4(true);
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm4({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm5 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "12") {
			setShow5(true);
			setForm5({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm5({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm5({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm6 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "3") {
			setShow6(true);
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm6({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm7 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow7(true);
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm7({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm8 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow8(true);
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm8({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm9 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow9(true);
			setForm9({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm9({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm9({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm10 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "0") {
			setShow10(true);
			setForm10({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm10({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm10({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm11 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "-2") {
			setShow11(true);
			setForm11({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm11({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm11({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm12 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "1") {
			setShow12(true);
			setForm12({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm12({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm12({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm13 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "2") {
			setShow13(true);
			setForm13({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm13({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm13({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm14 = (no1) => {
		const jwb = no1.target.value;
		if (jwb === "4") {
			setShow14(true);
			setForm14({
				width: "50px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm14({
				width: "50px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm14({
				width: "50px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm15 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "BENAR") {
			setShow15(true);
			setForm15({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm15({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm15({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	const handForm16 = (no1) => {
		const jwb = no1.target.value;
		if (jwb.toUpperCase() === "BENAR") {
			setShow16(true);
			setForm16({
				width: "60px",
				height: "30px",
				border: "6px solid #1aff66",
			});
		} else if (jwb === "") {
			setForm16({
				width: "60px",
				height: "30px",
				border: "6px solid yellow",
			});
		} else {
			setForm16({
				width: "60px",
				height: "30px",
				border: "6px solid red",
			});
		}
	};
	return (
		<div
			style={{
				margin: "auto",
				lineHeight: "35px",
				textAlign: "justify",
				width: "100%",
				borderStyle: "inset",
				borderColor: "green",
				borderRadius: "25px",
				fontSize: `${ukuranP}px`
			}}
			className="mt-2"
		>
			<div
				style={{
					width: "85%",
					margin: "auto",
				}}
			>
				<p className="text-center">
					Tentukanlah sistem pertidaksamaan untuk dearah yang tidak diarsir pada
					gambar di bawah ini
				</p>
				<div className="d-flex justify-content-center">
					<MediaQuery minWidth={476} maxWidth={1824}>
						<Iframe
							scrolling="no"
							title="Ch4Part4"
							src="https://www.geogebra.org/material/iframe/id/qpptredk/width/500/height/400/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
							width="500px"
							height="400px"
							allowFullScreen
						></Iframe>
					</MediaQuery>
					<MediaQuery maxWidth={475}>
						<Iframe
							scrolling="no"
							title="Ch4Part4"
							src="https://www.geogebra.org/material/iframe/id/qpptredk/width/500/height/400/border/888888/sfsb/true/smb/false/stb/false/stbh/false/ai/false/asb/false/sri/false/rc/false/ld/true/sdz/true/ctl/false"
							width="100%"
							style={{ height: "300px", border: "0px" }}
							allowFullScreen
						></Iframe>
					</MediaQuery>
				</div>
				<div
					style={{
						color: "green",
						display: "flex",
						justifyContent: "space-between",
						width: "10%",
					}}
				>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						<SkipNextIcon />
					</div>
					<p
						style={{ marginLeft: "22px", cursor: "pointer" }}
						onClick={clickSetJawaban4}
					>
						<strong>
							<u>Jawaban</u>
						</strong>
					</p>
					<div
						style={{
							width: "5px",
							height: "5px",
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						<SkipPreviousIcon />
					</div>
				</div>
				{jawaban4 ? (
					<div
						style={{
							width: "80%",
							margin: "auto",
							textAlign: "justify",
						}}
					>
						<p>
							Untuk menentukan sistem pertidaksamaan pada gambar diatas, harus
							ditentukan terlebih dahulu persamaan garis lurus yang menjadi
							batas-batas daerahnya, yakni dengan menggunakan rumus :{" "}
						</p>
						<div
							style={{
								display: "flex",
								justifyContent: "space-between",
								width: "60%",
								margin: "auto",
							}}
						>
							<>
								<table
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "30%",
										textAlign: "center",
									}}
								>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="x2" />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="x1" />
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="y2" />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="y1" />
										</td>
									</tr>
								</table>
							</>
							<div>
								<DoubleArrowIcon
									style={{
										width: "40px",
										height: "60px",
										color: "green",
									}}
								/>
							</div>
							<div>
								<InlineMath math=" \frac {y-y1} {y2-y1} = \frac {x-x1} {x2-x1} " />
							</div>
						</div>

						<ol>
							<li>
								Pertama kita ambil dahulu titik potong yang berwarna{" "}
								<b>hijau</b> pada sumbu <InlineMath math="\space x \space"/> dan titik potong yang berwarna <b>merah</b> pada sumbu <InlineMath math="\space y \space"/>
								yang tertera pada grafik soal. Coba kamu lengkapi dulu tabel di bawah ini!
							</li>
							<div class="d-flex justify-content-center mb-2">
								<table
									style={{
										border: "2px solid green",
										borderCollapse: "collapse",
										width: "30%",
										textAlign: "center",
									}}
								>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="x" />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<input type="text" onChange={handForm1} style={form1} />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<input type="text" onChange={handForm2} style={form2} />
										</td>
									</tr>
									<tr>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<InlineMath math="y" />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<input type="text" onChange={handForm3} style={form3} />
										</td>
										<td
											style={{
												border: "2px solid green",
												borderCollapse: "collapse",
											}}
										>
											<input type="text" onChange={handForm4} style={form4} />
										</td>
									</tr>
								</table>
							</div>

							{show1 && show2 && show3 && show4 ? (
								<>
									<p>
										Dengan menggunakan rumus yang ada di atas sebelum kalian
										memasukkan tabel, kita mendapatkan bahwa :
									</p>
									<div className="text-center">
										<InlineMath math="x2 = 4" />
									</div>
									<div className="text-center">
										<InlineMath math="x1 = 0" />
									</div>
									<div className="text-center">
										<InlineMath math="y2 = 0" />
									</div>
									<div className="text-center">
										<InlineMath math="y1 = 3" />
									</div>
									<p>
										Maka kalian dapat memasukkannya pada rumus, seperti di bawah
										ini :{" "}
										<i className="alert alert-warning">
											lengkapi form yang kosong
										</i>
									</p>
									<ul>
										<li style={{ marginBottom: "4px" }}>
											<InlineMath math="\dfrac {y-3}{0-3} = \dfrac {x-0} {4-0}" />
										</li>
										<li className="mt-2 mb-1">
											<InlineMath math="\dfrac {y-3}{-3} = \dfrac {x} {4}" />
										</li>
										<li>Selanjutnya kita kali silang, maka :</li>
										<li>
											<InlineMath math="4(y - 3) = -3x" />
										</li>
										<li>
											<InlineMath math="4y - 12 = -3x" />
										</li>
										<li>
											<input type="text" onChange={handForm6} style={form6} />
											x &nbsp;&nbsp; +
											<input type="text" onChange={handForm7} style={form7} />
											y &nbsp;&nbsp; =
											<input type="text" onChange={handForm5} style={form5} />
										</li>
									</ul>
									{show5 && show6 && show7 ? (
										<>
											<p className="alert alert-success mt-2">
												Dan kalian telah mendapatkan satu pertidaksamaan
											</p>
											<li>
												Selanjutnya kita ambil dahulu titik potong yang
												berwarna <b>hijau</b> pada sumbu <InlineMath math="\space x \space"/> dan titik potong yang berwarna{" "}
												<b>biru</b> pada sumbu <InlineMath math="\space y \space"/> yang tertera pada grafik soal. Coba kamu lengkapi dulu
												tabel di bawah ini!!
											</li>
											<div class="d-flex justify-content-center mb-2">
												<table
													style={{
														border: "2px solid green",
														borderCollapse: "collapse",
														width: "30%",
														textAlign: "center",
													}}
												>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="x" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handForm8}
																style={form8}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handForm9}
																style={form9}
															/>
														</td>
													</tr>
													<tr>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<InlineMath math="y" />
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handForm10}
																style={form10}
															/>
														</td>
														<td
															style={{
																border: "2px solid green",
																borderCollapse: "collapse",
															}}
														>
															<input
																type="text"
																onChange={handForm11}
																style={form11}
															/>
														</td>
													</tr>
												</table>
											</div>
											{show8 && show9 && show10 && show11 ? (
												<>
													<p>
														Dengan menggunakan rumus yang ada di atas sebelum
														kalian memasukkan tabel, kita mendapatkan bahwa :
													</p>
													<div className="text-center">
														<InlineMath math="x2 = 4" />
													</div>
													<div className="text-center">
														<InlineMath math="x1 = 0" />
													</div>
													<div className="text-center">
														<InlineMath math="y2 = 0" />
													</div>
													<div className="text-center">
														<InlineMath math="y1 = -2" />
													</div>
													<p>
														Maka kalian dapat memasukkannya pada rumus, seperti
														di bawah ini :{" "}
														<i className="alert alert-warning">
															lengkapi form yang kosong
														</i>
													</p>
													<ul>
														<li style={{ marginBottom: "4px" }}>
															<InlineMath math="\dfrac {y-(-2)}{0-(-2)} = \dfrac {x-0} {4-0}" />
														</li>
														<li className="mt-2 mb-1">
															<InlineMath math="\dfrac {y + 2}{ 2 } = \dfrac {x} {4}" />
														</li>
														<li>Selanjutnya kita kali silang, maka :</li>
														<li>
															<InlineMath math="4(y + 2) = 2x" />
														</li>
														<li>
															<InlineMath math="4y + 8 = 2x" />
														</li>
														<li>
															<InlineMath math="-2x + 4y = -8" />
														</li>
														<li>
															Selanjutnya kita sederhanakan agar variabel &nbsp;{" "}
															<InlineMath math="x" /> &nbsp; tidak negatif dan
															isilah form di bawah ini!
														</li>
														<li>
															<input
																type="text"
																onChange={handForm12}
																style={form12}
															/>
															<InlineMath math="x" /> &nbsp;&nbsp;{" "}
															<InlineMath math="-" />
															<input
																type="text"
																onChange={handForm13}
																style={form13}
															/>
															<InlineMath math="y" /> &nbsp;&nbsp; =
															<input
																type="text"
																onChange={handForm14}
																style={form14}
															/>
														</li>
													</ul>
													{show12 && show13 && show14 ? (
														<>
															<p className="alert alert-success mt-2">
																Dan kalian telah mendapatkan dua pertidaksamaan
															</p>
															<li>
																Langkah terakhir substitusikan titik koordinat
																(0,0) untuk memastikan bahwa bernilai benar.
															</li>
															<p className="alert alert-warning">
																Lengkapi form dengan memasukkan kata{" "}
																<b>Benar</b> atau <b>Salah</b>
															</p>
															<ul>
																<li>
																	Substitusikan{" "}
																	<InlineMath math="(0,0)\space ke \space  3x + 4y ≤ 12" />{" "}
																	, maka :
																</li>
																<ul>
																	<li>
																		<InlineMath math="3(0) + 4(0) ≤ 12 ." />
																	</li>
																	<li>
																		<InlineMath math=" 0 ≤ 12 ." />
																	</li>
																</ul>
																<li>
																	Maka bernilai{" "}
																	<input
																		type="text"
																		onChange={handForm15}
																		style={form15}
																	/>
																</li>

																<li>
																	Substitusikan{" "}
																	<InlineMath math="(0,0)\space ke \space x - 2y ≤ 4" />{" "}
																	, maka :
																</li>
																<ul>
																	<li>
																		<InlineMath math="(0)-2(0) ≤ 4 ." />
																	</li>
																	<li>
																		<InlineMath math=" 0 ≤ 4 ." />
																	</li>
																</ul>
																<li>
																	Maka bernilai{" "}
																	<input
																		type="text"
																		onChange={handForm16}
																		style={form16}
																	/>
																</li>
															</ul>
															{show15 && show16 ? (
																<>
																	<p>
																		Maka dapat dituliskan bahwa pertidaksamaan
																		yang daerahnya tidak diarsir pada daerah
																		penyelesaian adalah{" "}
																		<InlineMath math=" 3x + 4y ≤ 12 \space" />{" "}
																		dan{" "}
																		<InlineMath math=" x - 2y ≤ 4. \space" />.
																		Sehingga sistem pertidaksamaan linear untuk
																		gambar di atas adalah :
																	</p>
																	<b>
																		<MathComponent
																			tex={String.raw` 3x + 4y ≤ 12 ; x - 2y ≤ 4 `}
																		/>{" "}
																	</b>
																	<div className="mt-2">
																		<p style={{ textAlign: "justify" }}>
																			Selanjutnya agar memperdalam pemahaman
																			kamu, Ayo mari mencoba{" "}
																		</p>

																		<div className="d-flex justify-content-center align-items-center">
																			<button
																				className="btn btn-outline-success btn-sm mb-2"
																				onClick={openMencobaDialog}
																			>
																				<p
																					style={{
																						animation:
																							"scrollTop 0.3s alternate ease infinite",
																						marginTop: "10px",
																					}}
																				>
																					Mari Mencoba{" "}
																				</p>
																			</button>
																		</div>
																	</div>
																</>
															) : null}
														</>
													) : null}
												</>
											) : null}
										</>
									) : null}
								</>
							) : null}
						</ol>
					</div>
				) : null}

				<div>
					<Dialog
						fullScreen
						open={openmencobadialog}
						onClose={closemencobaDialog}
						TransitionComponent={Transition}
					>
						<AppBar className={classes.appBar}>
							<Toolbar>
								<IconButton
									edge="start"
									color="inherit"
									onClick={closemencobaDialog}
									aria-label="close"
								>
									<CloseIcon />
								</IconButton>
								<h4 className={classes.title}>
									Mari Mencoba Sistem Pertidaksamaan Linear
								</h4>
							</Toolbar>
						</AppBar>

						<Marimencoba />
					</Dialog>
				</div>
			</div>
		</div>
	);
};

export default Ch4;
